import {PropsWithChildren, ReactNode, useState} from 'react'
import {ChevronDownIcon, ChevronUpIcon} from '@/components/ui/icon/Icon'
import {useTranslation} from '@/translations/i18n.tsx'
import {
    StyledAccordion,
    StyledAccordionBody,
    StyledAccordionHeader,
    StyledAccordionTitleGroup,
    StyledFilterBadge
} from '@/features/mailer/components/mailer-accordion/style'

interface MailerFilterAccordionProps extends PropsWithChildren {
    icon: ReactNode
    title: string
    activeCount: number
    defaultOpen?: boolean
}

// Collapsible filter card, closed by default (design §5.3), with the
// active-filters badge (sky) or the "Nessun filtro" warning badge (amber).
export const MailerFilterAccordion = ({
    icon,
    title,
    activeCount,
    defaultOpen = false,
    children
}: MailerFilterAccordionProps) => {
    const {t} = useTranslation()
    const [isOpen, setIsOpen] = useState(defaultOpen)

    return (
        <StyledAccordion>
            <StyledAccordionHeader
                type="button"
                aria-expanded={isOpen}
                onClick={() => setIsOpen(previous => !previous)}
            >
                <StyledAccordionTitleGroup>
                    {icon}
                    <strong>{title}</strong>
                    <StyledFilterBadge $isActive={activeCount > 0}>
                        {activeCount > 0
                            ? t('mailer:filters_active_badge', {count: activeCount})
                            : t('mailer:filters_none_badge')}
                    </StyledFilterBadge>
                </StyledAccordionTitleGroup>
                {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
            </StyledAccordionHeader>
            {isOpen && <StyledAccordionBody>{children}</StyledAccordionBody>}
        </StyledAccordion>
    )
}

MailerFilterAccordion.displayName = 'MailerFilterAccordion'
